import React from 'react';
import { MarketBanner } from '@market/react';
import { useTranslation } from 'react-i18next';
import { dayjs } from 'utils/date';

/**
 * Banner informing customers about the migration from Loyalty Points to Local Cash
 * (Neighborhoods program). This banner can be removed once we decide to stop supporting
 * Loyalty --> Neighborhoods migrations.
 */

interface LocalCashMigrationBannerProps {
  migrationDate: string; // ISO 8601 format: YYYY-MM-DD
}

const LocalCashMigrationBanner: React.FC<LocalCashMigrationBannerProps> = ({
  migrationDate,
}) => {
  const { t } = useTranslation();

  // Format the date as "Mon DD, YYYY" (e.g., "Jan 11, 2026")
  const formattedDate = dayjs(migrationDate).format('MMM DD, YYYY');

  return (
    <MarketBanner className="mb-4">
      <div className="flex gap-3">
        <div className="flex-1">
          <div className="font-semibold mb-2">
            {t('loyalty.localCashMigration.title')}
          </div>
          <div className="text-sm mb-2">
            {t('loyalty.localCashMigration.description', {
              date: formattedDate,
            })}
          </div>
          <div className="text-sm">
            {t('loyalty.localCashMigration.continuationMessage', {
              date: formattedDate,
            })}
          </div>
        </div>
      </div>
    </MarketBanner>
  );
};

export default LocalCashMigrationBanner;
